module.exports = __webpack_public_path__ + "img/space-warper-lv2.ed832168.png";